import { Type, interface as iface, boolean } from 'io-ts';

export interface LabelInfo {
	Visible: boolean;
}

export const LabelInfo : Type<LabelInfo> = iface({
	Visible: boolean,
});
